var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"badge badge-warning ml-2"},[_vm._v(_vm._s(_vm.environmentName))])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }